import React, { useEffect } from "react";
import { sendClientLog } from 'services/logService';
import SearchBox from "components/explore/prospector/search/SearchBox";
import SuggestionList from "components/explore/prospector/search/SuggestionList";
import PageWrapper from "components/explore/prospector/layout/PageWrapper";
import Page from "components/explore/prospector/layout/Page";
import { getPropertySuggestions, getSessionToken } from "api/prospector/places";
import { Constants } from "utilities/constants";

const MIN_CHARS = Constants.MinSearchChars ?? 5;

function ExploreProspector({ browserLocation }) {
	const [suggestions, setSuggestions] = React.useState(null);
	const [token] = React.useState(getSessionToken());
	useEffect(() => {
		sendClientLog('Info', 'Explore - Prospector page loaded');
	}, []);

	async function handleInput(input) {
		if (input.length < MIN_CHARS) {
			setSuggestions(null);
		}
		else {
			const results = await getPropertySuggestions(input, token, browserLocation);
			setSuggestions(results);
		}
	}

	return (
		<Page>
			<PageWrapper>
				<SearchBox onInput={handleInput} /> 
				<SuggestionList suggestions={suggestions} />
			</PageWrapper>
		</Page>
	)
}

const ProspectorContainer = ExploreProspector;

export default ProspectorContainer;